<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .license-page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .license-summary {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(268px, 1fr));
    gap: 1rem;
  }
</style>

<script>
  import LicenseCard from "@sourcewhale/shared/svelte-design-system/components/molecules/LicenseCard/LicenseCard.svelte";
  import LicenseTable from "./LicenseTable.svelte";
  import TopContainer from "./TopContainer/TopContainer.svelte";

  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import AddLicensesModal from "../../elements/AddLicensesModal/AddLicensesModal.svelte";
  import { forceShowProjectsMarketingModalStore } from "../../modals/MarketingModal/ProjectsMarketingModal/stores.js";
  import { createAdminPanelContext } from "./context";

  const {
    modifiedTeamStore,
    showAddLicensesModalStore,
    licenseModalInitialAdditionStore,
    modulesStore,
  } = createAdminPanelContext();

  const onclose = () => {
    $showAddLicensesModalStore = false;
    $licenseModalInitialAdditionStore = "";
  };

  const makeOnClickAddLicenses = (license) => {
    const permissionObject = $modulesStore.find(
      (m) => m.kind === license.kind
    )?.permissionObject;
    if (license.kind === "projects") {
      return () => {
        if ($userStore.hasCrm) {
          const moreText =
            "You can’t add it on behalf of other teams. If you want to add it to this team, please log in with an account that belongs to the target team.";
          showToast({
            title: `Your account already has access to the Projects module. ${$userStore.isOnAnotherTeam ? moreText : ""}`,
            type: "danger",
          });
          return;
        }
        $forceShowProjectsMarketingModalStore = true;
      };
    }
    if (permissionObject === "team" && license.total === 0) {
      return () => {
        $licenseModalInitialAdditionStore = license.kind;
        $showAddLicensesModalStore = true;
      };
    }
    return permissionObject === "user" && license.activeCount >= license.total
      ? () => {
          $licenseModalInitialAdditionStore = license.kind;
          $showAddLicensesModalStore = true;
        }
      : null;
  };
</script>

<div class="license-page-container">
  <TopContainer />
  <div class="license-summary">
    {#if $modifiedTeamStore?.licenses}
      {#each $modifiedTeamStore.licenses as license}
        {@const onclick = makeOnClickAddLicenses(license)}
        {@const licenseInfo = {
          title: $modulesStore.find((m) => m.kind === license.kind)?.title,
          activeCount: license.activeCount,
          total: license.total,
        }}
        <LicenseCard
          {licenseInfo}
          type="external"
          permissionLevel={$modulesStore.find((m) => m.kind === license.kind)
            ?.permissionObject}
          {onclick}
        />
      {/each}
    {/if}
  </div>

  <LicenseTable />
</div>

{#if $showAddLicensesModalStore}
  <AddLicensesModal
    {onclose}
    licenseKind={$licenseModalInitialAdditionStore}
    modules={$modulesStore}
  />
{/if}
